module.exports = __webpack_public_path__ + "media/images/homepage/newsletter_mountains-07b01cf812c489e3d6a8f922ef39bbac.svg";